export default {
  metrics: {
    pickup: 'À emporter',
    internal_delivery: 'Livraison interne',
    external_delivery: 'Livraison externe',
  },
  events: {
    add_to_basket: 'Ajouter un article',
    begin_checkout: 'Passer à la caisse',
    begin_purchase: 'Initier le paiement',
    complete_purchase: 'Finaliser le paiement',
    order_placed: 'Finaliser le paiement',
    view_item: "Voir l'article",
  },
};
